export interface MasterItem {
  id: string;
  name: string;
  order: number;
}

export const classMasterItems: MasterItem[] = [
  { id: 'class-1', name: 'Pre-Primary - A', order: 1 },
  { id: 'class-2', name: 'Pre-Primary - B', order: 2 },
  { id: 'class-3', name: 'Primary - A', order: 3 },
  { id: 'class-4', name: 'Primary - B', order: 4 },
  { id: 'class-5', name: 'Secondary - A', order: 5 },
  { id: 'class-6', name: 'Secondary - B', order: 6 },
  { id: 'class-7', name: 'Pre-Vocational', order: 7 },
  { id: 'class-8', name: 'Vocational', order: 8 },
  { id: 'class-9', name: 'Care Group', order: 9 },
];

export const rolesMasterItems: MasterItem[] = [
  { id: 'role-1', name: 'Administrator', order: 1 },
  { id: 'role-2', name: 'Coordinator', order: 2 },
  { id: 'role-3', name: 'Special Educator', order: 3 },
  { id: 'role-4', name: 'Occupational Therapist', order: 4 },
  { id: 'role-5', name: 'Speech Therapist', order: 5 },
  { id: 'role-6', name: 'Physiotherapist', order: 6 },
  { id: 'role-7', name: 'Psychologist', order: 7 },
  { id: 'role-8', name: 'Class Teacher', order: 8 },
  { id: 'role-9', name: 'Assistant Teacher', order: 9 },
  { id: 'role-10', name: 'Caregiver', order: 10 },
];

export const sectionsMasterItems: MasterItem[] = [
  { id: 'section-1', name: 'A', order: 1 },
  { id: 'section-2', name: 'B', order: 2 },
  { id: 'section-3', name: 'C', order: 3 },
  { id: 'section-4', name: 'D', order: 4 },
];